/* eslint-env es6, commonjs */
module.exports = require('../dist/toast')
